import { render, staticRenderFns } from "./BetaSpecEditor.vue?vue&type=template&id=49400c35&scoped=true"
import script from "./BetaSpecEditor.vue?vue&type=script&lang=js"
export * from "./BetaSpecEditor.vue?vue&type=script&lang=js"
import style0 from "./BetaSpecEditor.vue?vue&type=style&index=0&id=49400c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49400c35",
  null
  
)

export default component.exports